import classNames from "classnames";
import { FC } from "react";

import { Typography } from "@/shared/ui";
import UsersIcon from "@/svgs/users_alt.svg";

import styles from "./role-button.module.scss";
import { RoleButtonProps } from "./role-button.types";

const RoleButton: FC<RoleButtonProps> = ({ title, description, selected = false, onClick }) => {
  return (
    <button className={classNames(styles.roleButton, selected && styles.selected)} onClick={onClick}>
      <div className={styles.header}>
        <UsersIcon className={styles.icon} />
        <Typography semi variant="subheadline">
          {title}
        </Typography>
      </div>

      {description && <Typography variant="footnote">{description}</Typography>}
    </button>
  );
};

export { RoleButton };
